export const BLOG_PAGE_TITLE = "Blog | Product Sourcing and Customization Insights";

export const BLOG_PAGE_DESCRIPTION = "Read practical articles about product sourcing, private label planning, sample coordination, and wholesale cooperation for global buyers.";

export const NEWS_ITEMS = [
  {
    id: "buying-guide-material-selection",
    category: "Buying Guide",
    date: "2026-03-26",
    cover: "/assets/blog/material-selection.jpg",
    tags: ["material", "price positioning", "retail"],
    title: "How to choose yoga product materials for different market price bands",
    title_zh: "如何针对不同市场价位段选择瑜伽产品材质",
    summary: "A practical framework for matching foam, cork, microfiber, and TPE options to target retail ranges and margin goals.",
    summary_zh: "一个实用的框架，用于将泡沫、软木、超细纤维和 TPE 选项与目标零售范围和利润目标相匹配。",
    body: "When evaluating new SKUs, start with target landed cost and expected shelf price, then reverse-map material options. For entry channels, stable thickness and anti-slip consistency usually matter more than niche material claims. For mid and premium channels, packaging quality, texture finish, and complaint-rate control become stronger purchase drivers than raw material labels alone.",
    body_zh: "在评估新 SKU 时，从目标到岸成本和预期上架价格开始，然后反向映射材质选项。对于入门渠道，稳定的厚度和防滑一致性通常比小众材质主张更重要。对于中高端渠道，包装质量、纹理外观和投诉率控制比单纯的原材料标签更具购买驱动力。"
  },
  {
    id: "customization-logo-packaging-checklist",
    category: "Customization",
    date: "2026-03-14",
    cover: "/assets/blog/oem-checklist.jpg",
    tags: ["private label", "logo", "packaging"],
    title: "Private-label checklist: logo process, packaging files, and approval timing",
    title_zh: "贴牌定制清单：Logo 流程、包装文件与确认节点",
    summary: "Reduce rework by aligning artwork format, print method, and sample approval milestones before bulk production.",
    summary_zh: "通过在批量生产前对齐艺术稿格式、印刷方式和样品确认里程碑来减少返工。",
    body: "Most avoidable delays happen between artwork confirmation and pre-production sample sign-off. Define logo placement tolerances, barcode ownership, insert language versions, and carton marks at the same time. A simple approval gate for digital mockup, physical sample, and pre-shipment visual check can cut late-cycle corrections significantly.",
    body_zh: "大多数可避免的延迟发生在艺术稿确认和产前样签核之间。同时定义 Logo 位置公差、条形码所有权、插卡语言版本和外箱唛头。对数字模型、实物样品和装船前视觉检查设置简单的确认关口，可以显著减少后期修正。"
  },
  {
    id: "sample-order-fast-evaluation",
    category: "Sample Order",
    date: "2026-02-28",
    cover: "/assets/blog/sample-strategy.jpg",
    tags: ["sample", "quality control", "lead time"],
    title: "Sample order strategy for faster supplier evaluation",
    title_zh: "快速评估供应商的样品订单策略",
    summary: "Use a two-round sample process to validate quality and communication speed before placing larger trial orders.",
    summary_zh: "在下大宗试订单前，使用两轮样品流程来验证质量和沟通速度。",
    body: "Round one should validate material feel, dimensions, and labeling basics. Round two should simulate your real sellable pack setup including inserts and master carton marks. Keep feedback in one consolidated checklist with clear pass-fail items so the supplier can respond in one revision cycle instead of fragmented updates.",
    body_zh: "第一轮应验证材质手感、尺寸和标签基础。第二轮应模拟真实的待售包装设置，包括插卡和主箱唛头。将反馈保持在一个统一的清单中，并附带明确的通过/失败项，以便供应商在一个修订周期内做出回应，而不是碎片化的更新。"
  },
  {
    id: "sourcing-risk-control",
    category: "Sourcing",
    date: "2026-02-12",
    cover: "/assets/blog/risk-control.jpg",
    tags: ["sourcing", "risk control", "compliance"],
    title: "Sourcing risk control before peak-season ordering",
    title_zh: "旺季下单前的采购风险控制",
    summary: "A short pre-order audit covering capacity, documentation readiness, and packaging consistency can reduce shipment uncertainty.",
    summary_zh: "一个简短的单前审核，涵盖产能、单证准备情况和包装一致性，可以减少发运的不确定性。",
    body: "Before peak season, verify production calendar assumptions with realistic throughput per line, not ideal capacity figures. Confirm compliance files and carton specifications are version-locked with the current SKU list. Early detection of mixed packaging standards is one of the highest-leverage steps for reducing warehouse-side relabeling and delayed receiving.",
    body_zh: "在旺季之前，根据每条线的实际吞吐量而非理想产能数字来验证生产计划假设。确认合规文件和纸箱规格与当前 SKU 列表版本锁定。早期发现混合的包装标准是减少仓库端重新贴标和延迟入库的最高杠杆步骤之一。"
  },
  {
    id: "product-tips-bundle-planning",
    category: "Product Tips",
    date: "2026-01-30",
    cover: "/assets/blog/bundle-planning.jpg",
    tags: ["bundle", "assortment", "repeat order"],
    title: "Bundle planning tips for improving repeat orders",
    title_zh: "提升复购率的组合规划建议",
    summary: "Pairing high-frequency accessories with hero SKUs can increase reorder stability and improve container utilization.",
    summary_zh: "将高频配件与核心 SKU 配对可以增加订单稳定性并提高集装箱利用率。",
    body: "Build bundle logic around usage scenarios, not only product categories. For example, combining recovery accessories with core yoga SKUs can improve average order value while keeping replenishment cycles predictable. Review damage-rate and packaging cube data per bundle to avoid hidden logistics costs.",
    body_zh: "围绕使用场景而非仅围绕产品类别构建组合逻辑。例如，将恢复类配件与核心瑜伽 SKU 结合可以提高平均订单金额，同时保持补货周期可预测。审查每个组合的损耗率和包装体积数据，以避免隐蔽的物流成本。"
  }
];
